import React from 'react';
import PropTypes from 'prop-types';
import { isSameDay, isBefore, isAfter, getMonth, getDate, startOfWeek, endOfWeek, eachDayOfInterval, getISOWeek, lastDayOfMonth, differenceInWeeks, addWeeks, getYear, isSameMonth, subWeeks, addDays, subDays } from 'date-fns';
import styled, { css, keyframes } from 'styled-components';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var isDateInRange = function isDateInRange(selectableDates) {
  return function (date) {
    if (!selectableDates) return true;
    if (Array.isArray(selectableDates)) return selectableDates.some(function (d) {
      return isSameDay(date, d);
    });

    if (selectableDates.before || selectableDates.after) {
      var inRange = true;
      if (selectableDates.before && !isBefore(date, selectableDates.before)) inRange = false;
      if (selectableDates.after && !isAfter(date, selectableDates.after)) inRange = false;
      return inRange;
    }

    return false;
  };
};
var getWeekdayNames = function getWeekdayNames(locale) {
  var weekdays = [];

  for (var day = 5; day <= 11; day++) {
    weekdays.push(new Date(1970, 1 - 1, day).toLocaleString(locale, {
      weekday: 'short'
    }));
  }

  return weekdays;
};
var getStyleProps = function getStyleProps(_ref) {
  var primaryColor = _ref.primaryColor,
      secondaryColor = _ref.secondaryColor,
      hoverColor = _ref.hoverColor;
  return {
    hoverColor: hoverColor,
    primaryColor: primaryColor,
    secondaryColor: secondaryColor
  };
};
var getPrimaryColor = function getPrimaryColor(props) {
  return props.primaryColor;
};
var getSecondaryColor = function getSecondaryColor(props) {
  return props.secondaryColor;
};
var getHoverColor = function getHoverColor(props) {
  return props.hoverColor;
};

var _templateObject;
var SVG = styled.svg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  fill: white;\n"])));
var ArrowRightIcon = (function (props) {
  return /*#__PURE__*/React.createElement(SVG, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.25h24v24H0z",
    fill: "none"
  }));
});

var _templateObject$1;
var SVG$1 = styled.svg(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  fill: white;\n"])));
var ArrowLeftIcon = (function (props) {
  return /*#__PURE__*/React.createElement(SVG$1, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h24v24H0z",
    fill: "none"
  }));
});

var _templateObject$2, _templateObject2, _templateObject3, _templateObject4;

function getBackground(props) {
  return props.isSelected ? getPrimaryColor(props) : getSecondaryColor(props);
}

function getTextColor(props) {
  var hoverColor = getHoverColor(props);
  if (props.isHeader) return getPrimaryColor(props);
  if (props.isIsoWeek) return 'rgb(113, 168, 189)';
  if (props.isSelected) return getSecondaryColor(props);
  if (!props.isAccessible) return hoverColor;
  if (props.isSameMonth) return 'rgb(51, 51, 51)';
  return hoverColor;
}

function getFontWeight(props) {
  return props.isHeader ? 'bold' : 'normal';
}

function getFontSize(props) {
  return props.isIsoWeek ? 12 : 14;
}

var DayContainer = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  ", "\n\n  &:focus {\n    outline: none;\n  }\n\n  ", "\n\n  ", "\n\n  transition: background-color .1s, color .1s;\n  font-weight: ", ";\n  font-size: ", "px;\n  background-color: ", "\n  border-radius: 1px;\n  color: ", ";\n  height: 42px;\n  width: 42px;\n  padding: 6px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])), function (_ref) {
  var isAccessible = _ref.isAccessible,
      isSelected = _ref.isSelected;
  return isAccessible && !isSelected && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      cursor: pointer;\n\n      &:hover {\n        background-color: ", ";\n      }\n    "])), getHoverColor);
}, function (props) {
  return props.isIsoWeek && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    border-right: 1px solid ", ";\n  "])), getHoverColor);
}, function (props) {
  return props.isFocussed && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    border: 1px solid ", ";\n    background-color: ", ";\n  "])), getPrimaryColor, getHoverColor);
}, getFontWeight, getFontSize, getBackground, getTextColor);

var Day = /*#__PURE__*/function (_React$Component) {
  _inherits(Day, _React$Component);

  var _super = _createSuper(Day);

  function Day() {
    _classCallCheck(this, Day);

    return _super.apply(this, arguments);
  }

  _createClass(Day, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_ref2) {
      var nextIsSelected = _ref2.isSelected,
          nextIsFocussed = _ref2.isFocussed;
      var _this$props = this.props,
          isSelected = _this$props.isSelected,
          isFocussed = _this$props.isFocussed,
          isHeader = _this$props.isHeader,
          isIsoWeek = _this$props.isIsoWeek;
      if (isHeader || isIsoWeek) return false;
      return nextIsSelected !== isSelected || nextIsFocussed !== isFocussed;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(DayContainer, this.props);
    }
  }]);

  return Day;
}(React.Component);

_defineProperty(Day, "propTypes", {
  primaryColor: PropTypes.string.isRequired,
  secondaryColor: PropTypes.string.isRequired,
  hoverColor: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isFocussed: PropTypes.bool.isRequired,
  isAccessible: PropTypes.bool.isRequired,
  isSameMonth: PropTypes.bool.isRequired,
  isHeader: PropTypes.bool.isRequired,
  isIsoWeek: PropTypes.bool.isRequired
});

_defineProperty(Day, "defaultProps", {
  isSelected: false,
  isFocussed: false,
  isAccessible: false,
  isSameMonth: false,
  isHeader: false,
  isIsoWeek: false
});

var _templateObject$3;
var WeekRow = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n"])));
var dateType = PropTypes.instanceOf(Date);

var Week = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Week, _React$PureComponent);

  var _super = _createSuper(Week);

  function Week() {
    var _this;

    _classCallCheck(this, Week);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderDay", function (day) {
      var _this$props = _this.props,
          onDateChange = _this$props.onDateChange,
          isDateInRange = _this$props.isDateInRange,
          focussedDate = _this$props.focussedDate,
          value = _this$props.value,
          month = _this$props.month;
      var isSelectable = isDateInRange(day);

      var onDayClick = function onDayClick(event) {
        if (isSelectable) onDateChange(day, event);
      };

      return /*#__PURE__*/React.createElement(Day, _extends({
        isSelected: isSameDay(day, value),
        isFocussed: isSameDay(focussedDate, day),
        isAccessible: isSelectable,
        isSameMonth: getMonth(day) === month,
        key: day.toString(),
        onClick: onDayClick
      }, getStyleProps(_this.props)), getDate(day));
    });

    _defineProperty(_assertThisInitialized(_this), "renderDays", function () {
      var _this$props2 = _this.props,
          date = _this$props2.date,
          weekStartsOn = _this$props2.weekStartsOn;
      var firstWeekday = startOfWeek(date, {
        weekStartsOn: weekStartsOn
      });
      var lastWeekday = endOfWeek(date, {
        weekStartsOn: weekStartsOn
      });
      return eachDayOfInterval({
        start: firstWeekday,
        end: lastWeekday
      }).map(_this.renderDay);
    });

    return _this;
  }

  _createClass(Week, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          date = _this$props3.date,
          displayIsoWeek = _this$props3.displayIsoWeek;
      return /*#__PURE__*/React.createElement(WeekRow, null, displayIsoWeek && /*#__PURE__*/React.createElement(Day, _extends({
        isIsoWeek: true
      }, getStyleProps(this.props)), getISOWeek(date)), this.renderDays());
    }
  }]);

  return Week;
}(React.PureComponent);

_defineProperty(Week, "propTypes", {
  primaryColor: PropTypes.string.isRequired,
  secondaryColor: PropTypes.string.isRequired,
  hoverColor: PropTypes.string.isRequired,
  date: dateType.isRequired,
  onDateChange: PropTypes.func.isRequired,
  isDateInRange: PropTypes.func.isRequired,
  focussedDate: dateType.isRequired,
  value: dateType.isRequired,
  month: PropTypes.number.isRequired,
  weekStartsOn: PropTypes.number.isRequired
});

var _excluded = ["date", "currentYear", "currentMonth"];

var _templateObject$4, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5, _templateObject6, _templateObject7;
var Header = styled.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  padding: 16px 8px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: ", ";\n  color: ", ";\n"])), getPrimaryColor, getSecondaryColor);
var CurrentMonth = styled.span(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  font-weight: bold;\n  font-size: 18px;\n"])));
CurrentMonth.displayName = 'CurrentMonth';
var MonthHeader = styled.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid ", ";\n"])), getHoverColor);
var MonthContainer = styled.div(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  padding: 8px 4px;\n"])), getSecondaryColor);
var ISOWeekHeader = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-right: 1px solid ", ";\n  font-size: 14px;\n  color: rgb(113, 168, 189);\n  height: 42px;\n  width: 42px;\n"])), getHoverColor);
var ArrowLeft = styled(ArrowLeftIcon)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  fill: ", ";\n"])), getSecondaryColor);
var ArrowRight = styled(ArrowRightIcon)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  fill: ", ";\n"])), getSecondaryColor);
var dateType$1 = PropTypes.instanceOf(Date);

var Calender = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Calender, _React$PureComponent);

  var _super = _createSuper(Calender);

  function Calender() {
    var _this;

    _classCallCheck(this, Calender);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderMonthHeader", function () {
      var _this$props = _this.props,
          locale = _this$props.locale,
          displayIsoWeek = _this$props.displayIsoWeek;
      var styleProps = getStyleProps(_this.props);
      var weekdays = getWeekdayNames(locale).map(function (weekday) {
        return /*#__PURE__*/React.createElement(DayContainer, _extends({
          isHeader: true,
          key: weekday
        }, styleProps), weekday);
      });
      return /*#__PURE__*/React.createElement(MonthHeader, styleProps, displayIsoWeek && /*#__PURE__*/React.createElement(DayContainer, _extends({
        isIsoWeek: true
      }, styleProps), "#"), weekdays);
    });

    _defineProperty(_assertThisInitialized(_this), "renderWeek", function (weekDate) {
      var _this$props2 = _this.props,
          date = _this$props2.date,
          currentYear = _this$props2.currentYear,
          currentMonth = _this$props2.currentMonth,
          props = _objectWithoutProperties(_this$props2, _excluded);

      return /*#__PURE__*/React.createElement(Week, _extends({
        value: date,
        year: currentYear,
        key: weekDate.toString(),
        month: currentMonth,
        date: weekDate
      }, props));
    });

    _defineProperty(_assertThisInitialized(_this), "renderHeader", function () {
      var _this$props3 = _this.props,
          previousMonth = _this$props3.previousMonth,
          nextMonth = _this$props3.nextMonth,
          currentMonth = _this$props3.currentMonth,
          currentYear = _this$props3.currentYear,
          locale = _this$props3.locale;
      var currentDate = new Date(currentYear, currentMonth);
      var monthNameFormatter = Intl.DateTimeFormat(locale, {
        month: 'long'
      });
      var styleProps = getStyleProps(_this.props);
      return /*#__PURE__*/React.createElement(Header, styleProps, /*#__PURE__*/React.createElement(ArrowLeft, _extends({
        onClick: previousMonth
      }, styleProps)), /*#__PURE__*/React.createElement(CurrentMonth, null, monthNameFormatter.format(currentDate), " ", currentYear), /*#__PURE__*/React.createElement(ArrowRight, _extends({
        onClick: nextMonth
      }, styleProps)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderWeeks", function () {
      var _this$props4 = _this.props,
          currentYear = _this$props4.currentYear,
          currentMonth = _this$props4.currentMonth,
          weekStartsOn = _this$props4.weekStartsOn;
      var firstDay = new Date(currentYear, currentMonth);
      var lastDay = lastDayOfMonth(firstDay);
      var weeks = [_this.renderWeek(firstDay)];
      var endOfFirstWeek = startOfWeek(lastDay, {
        weekStartsOn: weekStartsOn
      });
      var startOfLastWeek = endOfWeek(firstDay, {
        weekStartsOn: weekStartsOn
      });
      var weeksBetween = differenceInWeeks(endOfFirstWeek, startOfLastWeek);

      for (var i = 1; i <= weeksBetween; i++) {
        var nextWeek = addWeeks(firstDay, i);
        weeks.push(_this.renderWeek(nextWeek));
      }

      weeks.push(_this.renderWeek(lastDay));
      return weeks;
    });

    return _this;
  }

  _createClass(Calender, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderHeader(), /*#__PURE__*/React.createElement(MonthContainer, getStyleProps(this.props), this.renderMonthHeader(), this.renderWeeks()));
    }
  }]);

  return Calender;
}(React.PureComponent);

_defineProperty(Calender, "propTypes", {
  primaryColor: PropTypes.string.isRequired,
  secondaryColor: PropTypes.string.isRequired,
  hoverColor: PropTypes.string.isRequired,
  currentMonth: PropTypes.number.isRequired,
  currentYear: PropTypes.number.isRequired,
  date: dateType$1.isRequired,
  displayIsoWeek: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
  nextMonth: PropTypes.func.isRequired,
  nextYear: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
  previousMonth: PropTypes.func.isRequired,
  previousYear: PropTypes.func.isRequired,
  weekStartsOn: PropTypes.number.isRequired
});

var _templateObject$5, _templateObject2$2, _templateObject3$2, _templateObject4$2, _templateObject5$1;
var fadeIn = keyframes(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"])));
var tooltipAboveStyles = css(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  transform: translateY(calc(-100% - ", "px - 8px));\n"])), function (props) {
  return props.height;
});
var tooltipBelowStyles = css(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n  margin-top: 16px;\n"])));
var Tooltip = styled.div(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n  ", "\n\n  transform-origin: top center;\n  animation: ", " .2s;\n  position: absolute;\n  box-shadow: 0 0 8px 0px rgba(0,0,0,0.12);\n  border: 1px solid ", ";\n  z-index: 10;\n"])), function (props) {
  return props.showAbove ? tooltipAboveStyles : tooltipBelowStyles;
}, fadeIn, getPrimaryColor);
var Container = styled.div(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  z-index: 1000;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  &:focus {\n    outline: none;\n  }\n"])));
var dateType$2 = PropTypes.instanceOf(Date);

var Datepicker = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Datepicker, _React$PureComponent);

  var _super = _createSuper(Datepicker);

  function Datepicker(props) {
    var _this;

    _classCallCheck(this, Datepicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (event) {
      var element = event.target;

      if (_this.containerRef && !_this.containerRef.contains(element)) {
        _this.close();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "nextMonth", function () {
      return _this.setState(function (_ref) {
        var month = _ref.month,
            year = _ref.year;
        var wasLastMonthOfYear = month === 11;
        return {
          month: wasLastMonthOfYear ? 0 : month + 1,
          year: wasLastMonthOfYear ? year + 1 : year,
          focussedDate: new Date(year, month + 1, 1)
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "previousMonth", function () {
      return _this.setState(function (_ref2) {
        var month = _ref2.month,
            year = _ref2.year,
            focussedDate = _ref2.focussedDate;
        var isFirstMonthOfYear = !month;
        return {
          month: isFirstMonthOfYear ? 11 : month - 1,
          year: isFirstMonthOfYear ? year - 1 : year,
          focussedDate: new Date(year, month - 1, 1)
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "nextYear", function () {
      _this.setState(function (_ref3) {
        var year = _ref3.year;
        return {
          year: year + 1
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "previousYear", function () {
      _this.setState(function (_ref4) {
        var year = _ref4.year;
        return {
          year: year - 1
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleOpen", function () {
      _this.setState(function (_ref5) {
        var open = _ref5.open;
        return {
          open: !open
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      _this.setState({
        open: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setContainerRef", function (node) {
      _this.containerRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setFocussedDate", function (focussedDate) {
      _this.setState({
        focussedDate: focussedDate
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      var focussedDate = _this.state.focussedDate;

      switch (event.key) {
        case 'ArrowLeft':
          {
            event.preventDefault();
            var nextFocussedDate = subDays(focussedDate, 1);

            var isInRange = _this.isDateInRange(nextFocussedDate);

            if (!isInRange) return;
            if (!isSameMonth(nextFocussedDate, focussedDate)) _this.previousMonth();
            return _this.setFocussedDate(nextFocussedDate);
          }

        case 'ArrowRight':
          {
            event.preventDefault();

            var _nextFocussedDate = addDays(focussedDate, 1);

            var _isInRange = _this.isDateInRange(_nextFocussedDate);

            if (!_isInRange) return;
            if (!isSameMonth(_nextFocussedDate, focussedDate)) _this.nextMonth();
            return _this.setFocussedDate(_nextFocussedDate);
          }

        case 'ArrowUp':
          {
            event.preventDefault();

            var _nextFocussedDate2 = subWeeks(focussedDate, 1);

            var _isInRange2 = _this.isDateInRange(_nextFocussedDate2);

            if (!_isInRange2) return;
            if (!isSameMonth(_nextFocussedDate2, focussedDate)) _this.previousMonth();
            return _this.setFocussedDate(_nextFocussedDate2);
          }

        case 'ArrowDown':
          {
            event.preventDefault();

            var _nextFocussedDate3 = addWeeks(focussedDate, 1);

            var _isInRange3 = _this.isDateInRange(_nextFocussedDate3);

            if (!_isInRange3) return;
            if (!isSameMonth(_nextFocussedDate3, focussedDate)) _this.nextMonth();
            return _this.setFocussedDate(_nextFocussedDate3);
          }

        case 'Enter':
          {
            event.preventDefault();
            if (focussedDate) return _this.handleDateChange(focussedDate, event);
          }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isDateInRange", isDateInRange(_this.props.selectableDates));

    _defineProperty(_assertThisInitialized(_this), "handleDateChange", function (date, event) {
      _this.props.onChange(date, event);

      _this.close();
    });

    var initialDate = _this.date;
    _this.state = {
      focussedDate: initialDate,
      month: getMonth(initialDate),
      open: false,
      year: getYear(initialDate)
    };
    return _this;
  }

  _createClass(Datepicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "tooltipProps",
    get: function get() {
      if (!this.containerRef) return;
      var boundingRect = this.containerRef.getBoundingClientRect();
      var elementHeight = boundingRect.height;
      var distanceToBottom = window.innerHeight - boundingRect.bottom;
      return {
        height: elementHeight,
        showAbove: distanceToBottom < 400
      };
    }
  }, {
    key: "date",
    get: function get() {
      var _this$props = this.props,
          date = _this$props.date,
          onChange = _this$props.onChange;
      if (date && date instanceof Date && !isNaN(date)) return date; // Invalid dates will lead to rendering errors. Use the current date in that
      // case.

      var newDate = new Date();
      onChange(newDate);
      return newDate;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          weekStartsOn = _this$props2.weekStartsOn,
          selectableDates = _this$props2.selectableDates,
          children = _this$props2.children,
          className = _this$props2.className,
          dialogClassName = _this$props2.dialogClassName,
          displayIsoWeek = _this$props2.displayIsoWeek,
          locale = _this$props2.locale;
      var _this$state = this.state,
          month = _this$state.month,
          year = _this$state.year,
          open = _this$state.open,
          focussedDate = _this$state.focussedDate;
      var styleProps = getStyleProps(this.props);
      return /*#__PURE__*/React.createElement(Container, _extends({
        className: className,
        tabIndex: -1,
        ref: this.setContainerRef,
        onKeyDown: this.handleKeyDown
      }, styleProps), /*#__PURE__*/React.createElement("div", {
        onClick: this.toggleOpen
      }, children), open && /*#__PURE__*/React.createElement(Tooltip, _extends({
        className: dialogClassName
      }, this.tooltipProps, styleProps), /*#__PURE__*/React.createElement(Calender, _extends({
        currentMonth: month,
        currentYear: year,
        date: this.date,
        displayIsoWeek: displayIsoWeek,
        focussedDate: focussedDate,
        isDateInRange: this.isDateInRange,
        nextMonth: this.nextMonth,
        nextYear: this.nextYear,
        onDateChange: this.handleDateChange,
        previousMonth: this.previousMonth,
        previousYear: this.previousYear,
        selectableDates: selectableDates,
        setFocussedDate: this.setFocussedDate,
        weekStartsOn: weekStartsOn,
        locale: locale
      }, styleProps))));
    }
  }]);

  return Datepicker;
}(React.PureComponent);

_defineProperty(Datepicker, "propTypes", {
  className: PropTypes.string,
  dialogClassName: PropTypes.string,
  displayIsoWeek: PropTypes.bool,
  date: dateType$2,
  onChange: PropTypes.func.isRequired,
  primaryColor: PropTypes.string.isRequired,
  secondaryColor: PropTypes.string.isRequired,
  hoverColor: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  weekStartsOn: PropTypes.number.isRequired,
  selectableDates: PropTypes.oneOfType([PropTypes.arrayOf(dateType$2), PropTypes.shape({
    before: dateType$2,
    after: dateType$2
  })]),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
});

_defineProperty(Datepicker, "defaultProps", {
  date: new Date(),
  displayIsoWeek: true,
  hoverColor: '#d3d3d330',
  locale: 'de',
  primaryColor: '#27718c',
  secondaryColor: 'white',
  weekStartsOn: 1
});

export default Datepicker;
